import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PencilSquareSvg = function PencilSquareSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 6.68 17.32 2l-8.024 8.025v4.68h4.679zm-11.245 6.566v-2.617l6.566-6.566 2.616 2.617-6.566 6.566z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M11.849 4.126H2V22h17.874v-9.849h-1.46v8.39H3.46V5.585h8.39z"
    })]
  });
};
export var PencilSquare = function PencilSquare(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: PencilSquareSvg
  }));
};